<template>
  <div>
    <sHeader :activeIndex="3" />
    <div class="page-content">
      <SubCategory :categoryType="categoryType" :categories="categories" />
    </div>
  </div>
</template>

<script>
import sHeader from '@/components/templates/sHeader'
import SubCategory from '@/components/templates/SubCategory'

export default {
  components: {
    sHeader,
    SubCategory
  },
  methods: {
  },
  data () {
    return {
      categoryType: 'poem',
      categories: [
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/goy_duu.png',
          title: '歌',
          // route: '/Poem/ddd'
          // categoryType: 'Poem',
          id: '23'
        },
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/hamtaar_uyanglii.png',
          title: '诗',
          // route: '/Poem/ddd'
          // categoryType: 'Poem',
          id: '24'
        },
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/uran_helleg.png',
          title: '谚语',
          // route: '/Poem/ddd'
          // categoryType: 'Poem',
          id: '16'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Poem.vue